import React, {useEffect, useState} from 'react';
import style from './pagination.module.scss';
import next from "../../assets/icon/next.svg"

const toPersianNumber = (number) => {
    const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return number.toString().replace(/\d/g, x => farsiDigits[x]);
}


const Pagination = (props) => {
    const [color, setColor] = useState(JSON.parse(localStorage.getItem("theme")) ? JSON.parse(localStorage.getItem("theme")) : '#2196F3');
    const getTheme = () => {
        let tmpTheme = JSON.parse(localStorage.getItem("theme"));
        if (tmpTheme && tmpTheme !== "") {
            setColor(tmpTheme)
        } else {
            setColor('#2196F3')
        }
    }
    useEffect(() => {
        getTheme();
    });

    useEffect(() => {
        numberRenderer(4);
    }, [props.pageCount, props.currentPage]);


    const [numArray, setNumArray] = useState([]);
    const pushIfNotExist = (array, type) => {
        // console.log(array, "res res");
        if (type === "prev") {
            let result = array.indexOf("p");
            if (result === -1) {
                return true;
            }


        } else {
            let result = array.indexOf("n");

            if (result === -1) {
                return true

            }

        }


    }
    const doNothing = () => {
    }
    const numberRenderer = () => {
        let render = [];
        for (let i = 1; i <= props.pageCount; i++) {
            let x = i - props.currentPage;
            let y = props.pageCount - i;
            let z = i - 1;

            switch (true) {
                case (i == 1):
                    render.push(1);
                    break;
                case (x == -2 && z == 1):
                    render.push(i);
                    break;
                case (x == -1):
                    render.push(i);
                    break;
                case (x < 0): {
                    pushIfNotExist(render, "prev") ? render.push("p") : doNothing()
                }

                    break;
                case x == 0:
                    render.push(props.currentPage);
                    break;

                case (x == 1):
                    render.push(i);
                    break;
                case (y == 1 && x == 2):
                    render.push(i);
                    break;

                case (i == props.pageCount):
                    render.push(props.pageCount);
                    break;
                case (x > 0): {
                    pushIfNotExist(render, "next") ? render.push("n") : doNothing()
                }
                    break;

            }
        }
        setNumArray(render)
    }
    return (
        <div className={style.pagination}>
            <div className={style.paginationContainer}>
                <div
                    onClick={() => props.setPage(props.currentPage != 1 ? props.currentPage - 1 : props.currentPage, props.tag)}
                    className={props.currentPage === 1 ? style.hiddenFirst : style.firstPage}><img src={next}/></div>
                <div className={style.numberContainer}>{numArray.map((num, index) => {
                    if (num == "p" || num == "n") {
                        return (<div key={index} onClick={() => doNothing()} className={style.pageNumberDots}>
                            <div className={props.currentPage == num ? style.active : style.box}>
                                {"..."}
                            </div>
                        </div>);

                    } else {
                        return (
                            <div key={index} onClick={() => props.setPage(num, props.tag)} className={style.pageNumber}>
                                <div className={props.currentPage == num ? style.active : style.box}>
                                    {num == "p" || num == "n" ? "..." : toPersianNumber(num)}
                                </div>
                            </div>);


                    }

                })}</div>
                <div onClick={() => {
                    props.currentPage === props.pageCount || props.pageCount === 0 ? doNothing() : props.setPage(props.currentPage != props.pageCount ? props.currentPage + 1 : props.currentPage, props.tag)
                }}
                     className={props.currentPage === props.pageCount || props.pageCount === 0 ? style.hiddenLast : style.lastPage}>
                    <img src={next}/></div>
            </div>
        </div>
    )
}
export default Pagination;


// how to use:
//   props: 
//      props.currentPage = active page number should be integer 
//      props.pageCount = props.pageCount page that is acceptable also count of all page 
//      props,setPage = a function that get a number and set currentPage to that number

